import React from "react";

import { Button, EmptyState, SectionCard, Skeleton, Stack } from "shared/ui";

import { OrdersFilters } from "features/Orders/components/OrdersFilters";
import { OrdersTable } from "features/Orders/components/OrdersTable";
import { OrdersContext } from "features/Orders/context";
import { useOrdersState } from "features/Orders/hooks/useOrdersState";

import { Container, Message } from "./styles";

const OrdersScreen = () => {
    const state = useOrdersState();

    if (state.loading) {
        return (
            <Container>
                <Stack>
                    <Skeleton height="44px" width="420px" />
                    <Skeleton height="360px" />
                </Stack>
            </Container>
        );
    }

    if (state.error) {
        return <Message>Не удалось загрузить заказы</Message>;
    }

    const renderBody = () => {
        if (state.menuId === null) {
            return (
                <EmptyState
                    title="Нет меню"
                    description="Заказы приходят из меню — сначала должно появиться хотя бы одно."
                />
            );
        }

        if (state.listError) return <Message>Не удалось загрузить заказы</Message>;

        if (state.orders.length === 0) {
            // Скелетон вместо пустоты: без него на время запроса мелькает «заказов нет».
            if (state.listLoading) return <Skeleton height="360px" />;

            return state.isFiltered ? (
                <EmptyState
                    title="Ничего не найдено"
                    description="За выбранный период и по выбранным фильтрам заказов нет."
                    action={
                        <Button variant="text" onClick={state.resetFilters}>
                            Сбросить фильтры
                        </Button>
                    }
                />
            ) : (
                <EmptyState
                    title="Заказов пока нет"
                    description="Здесь появятся заказы гостей за выбранный период — сегодня их ещё не было."
                />
            );
        }

        return <OrdersTable />;
    };

    return (
        <OrdersContext.Provider value={state}>
            <Container>
                <SectionCard
                    title="Заказы"
                    description="Заказы гостей выбранного меню за период. Нажмите на номер, чтобы открыть состав, историю статусов и возврат"
                >
                    {/* Без меню фильтровать нечего: пустой селект и чипы только сбивают. */}
                    {state.menuId !== null && <OrdersFilters />}
                    {renderBody()}
                </SectionCard>
            </Container>
        </OrdersContext.Provider>
    );
};

export const Orders = OrdersScreen;
